module.exports = __webpack_public_path__ + "img/zoetrope.1e1c666d.png";